import { Checkbox, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { createWashingSieveSizeSelector } from '../../../helpers';

const ResultsSectionContentBase = ({ createWorksheetSelector }: IWorksheetComponent) => {
  const washingSieveSizeCaption = useSelector(
    pipe(createWashingSieveSizeSelector(createWorksheetSelector!), (s) => s?.Caption ?? 'No. 200')
  );

  return (
    <Field
      label={`Passing ${washingSieveSizeCaption} (%)`}
      input={<TextOutput />}
      name="Results.PercentPassingWashingSieve"
    />
  );
};

const ResultsSectionContent = withInjectedProps(ResultsSectionContentBase);

const ResultsSectionBase = ({ createWorksheetSelector }: IWorksheetComponent) => {
  const disableReportInsufficientSampleMass = useSelector(
    pipe(
      createWorksheetSelector!('Masses.IsMinimumMassAchieved'),
      (isMinimumMassAchieved: boolean | undefined | null) => isMinimumMassAchieved !== false
    )
  );
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <ResultsSectionContent />
      </ListFieldSection>
      <ListFieldSection heading="Report" single>
        <Field
          input={<Checkbox />}
          label="Insufficient sample available"
          name="Results.ReportMinimumMassNotAchieved"
          disabled={disableReportInsufficientSampleMass}
        />
      </ListFieldSection>
    </>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export { ResultsSection };
